// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1gm9R","form":"styles_form__4gHTh"};